import ReactCompareImage from 'react-compare-image';
import conEscenarioJc from "../../../../proyectos/set-escenario-virtual-convencion-streaming-mexico/CuervoVP-conEscenarioVirtual2jc.jpg";
import sinEscenarioJc from "../../../../proyectos/set-escenario-virtual-convencion-streaming-mexico/CuervoVP-greenScreenjc2.jpg";
import * as React from 'react';
export default {
  ReactCompareImage,
  conEscenarioJc,
  sinEscenarioJc,
  React
};